document.addEventListener("DOMContentLoaded", function() {

    // detail videoprohlídka - youtube
    (function () {
        if(typeof (lightGallery) === 'undefined')
            return;

        const video = document.querySelector('.JS-detail-video-play');

        if (typeof (video) !== 'undefined' && video !== null)
            lightGallery(video,  {
                licenseKey: '9F006080-20BA-4E4D-8CD1-1EEF91BC50ED',
                selector: 'this', 
                iframeMaxWidth: '80%',
                iframeMaxHeight: '80%',
                autoplayFirstVideo: true,
                download: false,
                counter: false,
                videoMaxWidth: '80%',
                youtubePlayerParams: {
                    modestbranding: 1,
                    showinfo: 0,
                    rel: 0,
                    controls: 0
                },
                startClass: ''
            });

        // detail videoprohlídka - video soubor
        const file = document.querySelector('.JS-detail-video-play-file');
        if (typeof (file) !== 'undefined' && file !== null)
            lightGallery(file, {
                licenseKey: '9F006080-20BA-4E4D-8CD1-1EEF91BC50ED',
                videoMaxWidth: '80%',
                plugins: [lgVideo]
            });

        // detail matterport - oddělené tlačítko
        const matterport = document.querySelector('.JS-detail-matterport-play');
        if (typeof (matterport) !== 'undefined' && matterport !== null)
            lightGallery(matterport, {
                selector: 'this',
                iframeMaxWidth: '80%',
                iframeMaxHeight: '80%',
                download: false,
                counter: false,
                videoMaxWidth: '80%',
                licenseKey: '9F006080-20BA-4E4D-8CD1-1EEF91BC50ED',
            });
    }());


    // otevři facebook v novém okně
    let facebookLink = document.querySelector('.JS-facebook');
    if(typeof(facebookLink) != 'undefined' && facebookLink != null) {
        facebookLink.addEventListener("click", function () {
            window.open(this.href, 'title', 'width=783,height=268,top=300,left=650');
            return false;
        });
    }

    let headImage = document.querySelector('.JS-head-image');
    if(typeof(headImage) != 'undefined' && headImage != null){
        headImage.addEventListener("click", function() {
            document.querySelector('.JS-lightgallery-item').dispatchEvent(new Event('click'));
        });
    }
});